module.exports = __webpack_public_path__ + "static/media/moderator-new-question-last-frame.8a18248c.png";